import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { LogService } from '@services/log.service';
import { TankProfileService } from '@services/tank-profile.service';
import { BehaviorSubject, delay } from 'rxjs';

@Component({
  selector: 'app-view-tank-profile-details-pop-up',
  templateUrl: './view-tank-profile-details-pop-up.component.html',
  styleUrls: ['./view-tank-profile-details-pop-up.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewTankProfileDetailsPopUpComponent implements OnInit {
  tankProfile: any = null;

  isLoading$ = new BehaviorSubject<boolean>(true);
  isLoading = this.isLoading$.asObservable();

  private _tankProfileId: number;
  public get tankProfileId(): number {
    return this._tankProfileId;
  }

  get selectedColumns(): string[] {
    return this.tankProfile?.tankGridColumns
      .filter((c) => c.isSelected)
      .map((c) => c.columnName)
      .sort();
  }

  @Input()
  public set tankProfileId(value: number) {
    this._tankProfileId = value;
    this.tankProfile = null;
  }

  @Input() linkText: string = 'View';

  constructor(
    private _tps: TankProfileService,
    private _cdr: ChangeDetectorRef,
    private _logger: LogService
  ) {}

  ngOnInit() {}

  onPopupOpen() {
    this.loadTankProfile();
  }

  private loadTankProfile() {
    this.isLoading$.next(true);
    this._cdr.detectChanges();
    this._tps.getTankProfile(this.tankProfileId).subscribe((tankProfile) => {
        this.tankProfile = tankProfile;
        this.isLoading$.next(false);
        this._cdr.detectChanges();
        this._logger.info('Tank Profile details', tankProfile);
    });
  }
}
